import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "../components/legal-page";

export const Route = createFileRoute("/legal/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy" },
      { name: "description", content: "Cookies set by the HR Service Centre website and how to manage your preferences under PECR and UK GDPR." },
      { property: "og:title", content: "Cookie Policy" },
      { property: "og:url", content: "https://www.hrservicecentre.co.uk/legal/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://www.hrservicecentre.co.uk/legal/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <LegalPage
      title="Cookie Policy"
      intro="This policy explains the cookies and similar technologies this site uses, what they do, and how you can control them."
      lastReviewed="2026-09-14"
    >
      <h2>What are cookies</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. We also use similar technologies
        such as local storage. We use them to make the site work and, with your consent, to understand how it's used.
      </p>

      <h2>Your choice</h2>
      <p>
        When you first visit, a banner asks whether you accept optional cookies. Nothing beyond strictly necessary
        storage is set until you choose "Accept all". If you decline, no analytics cookies are set and the site
        continues to work normally.
      </p>

      <h2>Categories we use</h2>
      <h3>Strictly necessary</h3>
      <p>
        Required for core functions such as remembering your cookie choice, keeping forms and any signed-in admin
        session working, and basic security. These are set without consent, as PECR allows.
      </p>
      <h3>Analytics (optional)</h3>
      <p>
        We use Google Analytics to understand which pages, guides and calculators are most useful, how people arrive
        at the site and where they drop off. These cookies are only loaded after you select "Accept all". The data is
        used in aggregate and is not used to identify you personally.
      </p>

      <h2>Managing your preferences</h2>
      <p>
        You can withdraw consent at any time by clearing cookies and site data for this site in your browser, then
        reloading the page so the banner appears again and choosing differently. Most browsers also let you block or
        delete cookies for individual sites in their settings.
      </p>

      <h2>Related policies</h2>
      <p>
        How we handle personal data more generally is set out in our{" "}
        <Link to="/legal/privacy">Privacy Policy</Link>. Questions about cookies can be sent through our{" "}
        <Link to="/contact-hr-experts">contact form</Link>.
      </p>

      <h2>More information</h2>
      <p>
        For background on cookies and your rights, see the ICO guidance at{" "}
        <a href="https://ico.org.uk/for-the-public/online/cookies/">ico.org.uk/for-the-public/online/cookies</a>.
      </p>
    </LegalPage>
  );
}
